module.exports = Promise.resolve(parcelRequire("4Q5V1"))